// Shared tab scaffolding: load state, error state, empty state.
import type { ReactNode } from 'react';
import type { TrendsEnvelope } from '../types';

const STALE_MINUTES_5 = 5 * 60_000;

export const QUERY_OPTIONS = {
  staleTime: STALE_MINUTES_5,
  refetchOnWindowFocus: false,
} as const;

export function TabStatus({
  isLoading,
  isError,
  error,
  data,
  emptyHint,
  children,
}: {
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  data: TrendsEnvelope | undefined;
  emptyHint: string;
  children: ReactNode;
}) {
  if (isLoading) {
    return <div className="trends-state trends-state-loading">Loading…</div>;
  }
  if (isError) {
    const msg = error instanceof Error ? error.message : String(error);
    return (
      <div className="trends-state trends-state-error">
        <strong>Couldn’t load this tab.</strong>
        <div className="trends-state-detail">{msg}</div>
      </div>
    );
  }
  if (!data || data.empty) {
    return (
      <div className="trends-state trends-state-empty">
        <strong>Nothing to show yet.</strong>
        <div className="trends-state-detail">{emptyHint}</div>
      </div>
    );
  }
  return <>{children}</>;
}

export function BuiltAt({ at }: { at: string | null }) {
  if (!at) return null;
  return <div className="trends-built-at">Snapshot built {at}</div>;
}
